<template>
    <div class="main-container">
        <my-header></my-header>
        <div class="container">
            <h1 style="text-align: center;font-size: 22px;display: table;"></h1>
            <!--合同信息-->
            <section class="small-container" style="margin-top: 20px;">
                <h3 class="iconfont iconxiala" style="display: inline">合同信息</h3>
                <el-button v-if="come === 'apply'" type="primary" size="mini" @click="submit" style="display: inline;margin-left: 850px;color: white;font-size: 12px">提交申请</el-button>
                <!-- <h3 v-else class="iconfont" style="display: inline;margin-left: 750px">履约得分：{{info.score}} </h3> -->
                <h3 v-else class="iconfont" style="display: inline;margin-left: 750px"></h3>
                <el-row class="colorLine" style="margin-top: 10px">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form size="mini" disabled :inline="true" class="demo-form-inline" :model="info" label-width="200px" style="margin-top: 10px;min-height: 300px">
                    <el-col :span="12">
                        <el-form-item label="合同名称" prop="contactName">
                            <el-input v-model="info.contactName" placeholder="合同名称" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="合同编码" prop="contactCode">
                            <el-input v-model="info.contactCode" placeholder="合同编码" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同总额(含税)" prop="paidAmount">
                            <el-input v-model="info.paidAmount" placeholder="合同总额(含税)" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="合同状态">
                            <el-input v-model="info.contractStatus" placeholder="合同状态" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="计价方式">
                            <el-input v-model="info.valuationType" placeholder="计价方式" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="合同签订日期">
                            <el-input v-model="info.signTime" placeholder="合同签订日期" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同开始日期">
                            <el-input v-model="info.startTime" placeholder="合同开始日期" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="合同结束日期">
                            <el-input v-model="info.endTime" placeholder="合同结束日期" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="签订金额">
                            <el-input v-model="info.signContactAmount" placeholder="签订金额" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="合同类型">
                            <el-input v-model="info.contactTypeName" placeholder="合同类型" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-form-item label="应付未付金额">
                            <el-input v-model="info.remainAmount" placeholder="应付未付金额" size="mini"></el-input>
                        </el-form-item> -->
                        <el-form-item label="已付金额">
                            <el-input v-model="info.paidAmount" placeholder="已付金额" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </section>
            <!--付款计划-->
            <section v-if="come === 'see'" class="small-container">
                <h3 class="iconfont iconxiala" style="display: inline">付款计划</h3>
                <el-row class="colorLine" style="margin-top: 10px">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-table disabled :data="info.detailsList" size="mini" style="width: 100%;padding: 15px 45px;">
                    <el-table-column label="序号" type="index"/>
                    <el-table-column label="节点名称" prop="nodeName"/>
                    <el-table-column label="节点金额(含税)" prop="paymentAmount"/>
                    <el-table-column label="未付金额" prop="planBalanceAmount"/>
                    <el-table-column label="节点比例" prop="paymentPercent"/>
                    <el-table-column label="付款时间" prop="planPaymentDate"/>
                </el-table>
            </section>
            <!--款项信息-->
            <section v-if="come !== 'see'" class="small-container">
                <h3 style="display: inline">&nbsp;</h3>
                <h3 class="iconfont iconxiala">款项信息</h3>
                <el-row class="colorLine" style="margin-top: 10px">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
<!--                <el-form size="mini" disabled :model="info" label-width="200px" style="margin-top: 10px">-->
<!--                    <el-row>-->
<!--                        <el-col :span="24" prop="">-->
<!--                            <el-form-item label="节点名称">-->
<!--                                <el-input v-model="info.nodeName" placeholder="款项名称" size="mini"></el-input>-->
<!--                            </el-form-item>-->
<!--                        </el-col>-->
<!--                        <el-col :span="12">-->
<!--                            <el-form-item label="节点比例">-->
<!--                                <el-input v-model="info.payment_percent" placeholder="节点比例" size="mini"></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="应付金额">-->
<!--                                <el-input v-model="info.payment_amount" placeholder="应付金额" size="mini"></el-input>-->
<!--                            </el-form-item>-->
<!--                        </el-col>-->
<!--                        <el-col :span="12">-->
<!--                            <el-form-item label="未付金额">-->
<!--                                <el-input v-model="info.plan_balance_amount" placeholder="未付金额" size="mini"></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="计划付款日期">-->
<!--                                <el-input v-model="info.plan_payment_date" placeholder="计划付款日期" size="mini"></el-input>-->
<!--                            </el-form-item>-->
<!--                        </el-col>-->
<!--                    </el-row>-->
<!--                </el-form>-->
                <el-form size="mini" disabled :inline="true" class="demo-form-inline" :model="info" label-width="200px" style="margin-top: 10px">
                    <el-row>
                        <el-col :span="24" prop="">
                            <el-form-item label="节点名称">
                                <el-input v-model="data.nodeName" placeholder="款项名称" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="节点比例">
                                <el-input v-model="data.paymentPercent" placeholder="节点比例" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="应付金额">
                                <el-input v-model="data.paymentAmount" placeholder="应付金额" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="未付金额">
                                <el-input v-model="data.planBalanceAmount" placeholder="未付金额" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="计划付款日期">
                                <el-input v-model="data.planPaymentDate" placeholder="计划付款日期" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
            <!--价格库清单-->
            <section v-if="come === 'order'" class="small-container">
                <h3 class="iconfont iconxiala">价格库清单</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div class="marg-top-cls">
                    <priceTable ref="priceTable" :editable="false" page="orderAdd" style="margin-top: -20px;"></priceTable>
                </div>
            </section>
            <!--新增清单-->
            <section v-if="come === 'order'" class="small-container">
                <h3 class="iconfont iconxiala">新增清单</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div class="marg-top-cls">
                    <priceTableInput :readonly="true" page="orderAdd" ref="priceTableInput" style="margin-top: -20px;"></priceTableInput>
                </div>
            </section>
            <!--备注信息-->
            <section v-if="come === 'apply' || come === 'order'" class="small-container">
                <h3  class="iconfont iconxiala">备注</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form>
                    <el-row>
                        <el-col :span="24">
                            <el-input type="textarea"
                                        :maxlength="500" v-model="info.remark"
                                      style="margin: 5px 20px;height: 320px" size="mini"></el-input>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
        </div>
    </div>
</template>

<script>
    import MyHeader from '../common/Header.vue'
    import priceTable from '../order/components/priceTable';
    import priceTableInput from '../order/components/priceTableInput';
export default {
    name: "contract",
    components: {
        priceTable,
        priceTableInput,
        MyHeader,
    },
    data() {
        return {
            id: this.$route.params.cid,
            approve_id:'',
            info: {
                detailsList:[
                    {

                    }
                ],
                remark:'',
                score:'0'
            },
            pay_info:{

            },
            data: {},
            come: this.$route.params.type,
            tableData1:[],
            tableData2:[],
            addedPriceList:[],
        }
    },
    methods: {
        submit(){
            let that = this;
            let params = {
                id:this.approve_id,
                applyContent:this.info.remark
            }
            let url = '/v1/outerformflowHS/approveContract'
            this.$root.postHttp(url, params,function (res) {
                console.log(res)
                that.$alert('提交成功', '提示', {
                    confirmButtonText: '确定',
                    type: 'success',
                    callback: action => {
                        that.$router.go(-1);
                    }
                });
            })
        },
        getData() {
            if (this.come === 'see'){
                let that = this;
                let url = '/v1/outerformflowHS/getContractInfo/' + this.id
                this.$root.getHttp(url, function (res) {
                    console.log(res)
                    that.info = res.data.data
                })
            } else if (this.come === 'check' || this.come === 'apply'){
                let that = this;
                let url = '/v1/outerformflowHS/approveContractInfo/' + this.id
                this.$root.getHttp(url, function (res) {
                    console.log(res)
                    that.info = res.data.data.extSContact
                    that.data = res.data.data
                    that.approve_id = res.data.data.id
                })
            } else if(this.come === 'order'){
                let that = this;
                let url = '/v1/sOrders/getOrderDetail/' + this.id
                this.$root.getHttp(url, function (res) {
                    console.log(res)
                    that.info = res.data.data.scontact
                    that.approve_id = res.data.data.id
                    // that.tableData1 = res.data.data.storeDetails
                    // that.tableData2 = res.data.data.newDetails
                    that.getCategoryInfo(res.data.data.scontact.categoryId, (data)=>{
                        let priceTableRef = that.$refs['priceTable'];
                        if(priceTableRef){
                            priceTableRef.setData(res.data.data.storeDetails, data);
                        }
                        let priceTableInputRef = that.$refs['priceTableInput'];
                        if(priceTableInputRef){
                            that.addedPriceList = res.data.data.newDetails||[]
                            that.addedPriceList.map(item=>{
                                let taxRatioAmount = that.$root.accMinus(item.amountWithTax,item.amountExclTax);
                                item.taxRatioAmount = taxRatioAmount;
                            })
                            priceTableInputRef.setData(that.addedPriceList, data);
                        }
                    })
                })
            }
        },
        getCategoryInfo(id,fn){
            let that = this;
            debugger
            that.$root.getHttp('/v1/sSuppliersCategory/getCategoryInfo/'+id, function (res) {
                fn && fn(res.data.data);
            })
        },
    },
    created() {
        this.getData()
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/_var.scss';
@import "../../assets/iconfont/iconfont.css";

.main-container {
    width: 1100px;
    text-align: left;
}

.container /deep/ {
    margin-top: 60px;
    margin-bottom: 150px;
    padding-bottom: 15px;
    background-color: #ffffff;

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }

    .f14 {
        font-size: 14px !important;
    }

    & .unit {
        width: 100px;
        margin-right: 5px;
    }

    & .tip {
        margin-left: 10px;
        color: $--primary-color;
        font-size: 12px;
    }

    & .add {
        float: right;
        font-size: 14px;
        cursor: pointer;

        & img {
            vertical-align: middle;
            width: 70px;
            height: 26px;
        }
    }

    & .dele {
        position: absolute;
        top: 0px;
        right: 10px;
    }

    & .dele img {
        transform: scale(1);
        transition: .5s;
        width: 34px;
        height: 34px;
    }

    .dele:hover img {
        transform: scale(1.1);
    }

    & .remarks {
        width: 95%;
    }

    & .naturalForm {
        padding: 20px 10px 5px;
        padding-left: 0px;
        padding-right: 26px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-bottom: 20px;
    }

    & h4 {
        padding: 0 30px;
        text-align: left;
        line-height: 50px;
        color: $--text-color-light;
        background: $--secondary-fill-color;
        overflow: hidden;
        position: relative;
    }

    & h4 {
        text-indent: 10px;
        line-height: 35px;
        background: $--primary-fill-color;
    }

    & h5 {
        padding: 0 30px;
    }

    .el-input__inner {
        border: none;
        border-bottom: 1px solid #C4C4C4;
        border-radius: 0px;
    }

    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        cursor: default;
    }
    .el-textarea__inner{
        height: 120px;
    }

    .maxWidthForm {
        width: 100%;

        .el-form-item__content {
            width: calc(100% - 260px);
        }
    }

    .maxWidthForm-2 {
        width: 100%;

        .el-form-item__content {
            width: calc(100% - 100px);
        }
    }

    .el-form-item {
        width: 100%;
    }
    .el-form-item__error {
        width: 300px;
        padding: 0;
    }

    .el-form-item__label, .el-form-item__content{
        line-height: 33px;
    }

}

.box-card {
    margin-bottom: 15px;
}

.minWidth {
    width: 250px;
}

h3 {
    // background-color: #ececec;
    padding: 5px 20px;
    margin: 0;
    // margin-top: 10px;
    position: relative;
    cursor: pointer;
}

.iconxiala::before {
    position: absolute;
    left: -5px;
    font-size: 20px;
}

.colorLine {
    margin-bottom: 20px;
    padding-left: 20px;
}

h2 {
    font-size: 13px;
    margin-left: 20px;
}

.noMarginBottom {
    // margin-bottom: 0!important;
    margin-bottom: 10px !important;

    .tipWrap {
        position: relative;
        min-width: 250px;

        .tips {
            position: absolute;
            top: 16px;
            left: 100px;
            padding-left: 20px;
            font-size: 12px;
            color: $--text-color-light;
            background: url('../../assets/images/register/tip.png') no-repeat left center;
        }
    }
}

.cf:before,
.cf:after {
    content: "";
    display: table;
}

.cf:after {
    clear: both;
}

.attachmentDiv /deep/ {
    text-align: left;

    .file-list {
        margin-top: 10px;
    }
}

.marg-top-cls{
    padding-left: 15px;
    margin-bottom: 20px;
}
</style>




// WEBPACK FOOTER //
// src/pages/contract/contract.vue